import { render } from "./ModalReverseRecord.vue?vue&type=template&id=468a04e6"
import script from "./ModalReverseRecord.vue?vue&type=script&lang=js"
export * from "./ModalReverseRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__